/**
 * Pure helpers that back the CampaignLink / LineItemLink components.
 * Kept separate from CardLinks.tsx so URL construction and null-guard
 * predicates can be unit-tested without rendering React.
 */

export type LineItemPhase = 'proposal' | 'execution';

export function buildCampaignPath(campaignId: string): string {
  return `/campaigns/${campaignId}`;
}

export function buildLineItemPath(
  campaignId: string,
  lineItemId: string,
  sourcePhase: string | null | undefined
): string {
  const phase = resolveLineItemPhase(sourcePhase);
  return `/campaigns/${campaignId}/${phase}/lineitems/${lineItemId}`;
}

export function resolveLineItemPhase(sourcePhase: string | null | undefined): LineItemPhase {
  return sourcePhase === 'proposal' ? 'proposal' : 'execution';
}

export function canRenderCampaignLink(
  campaignId: string | null | undefined,
  campaignName: string | null | undefined
): boolean {
  return Boolean(campaignId && campaignName);
}

export function canRenderLineItemLink(
  campaignId: string | null | undefined,
  lineItemId: string | null | undefined,
  lineItemName: string | null | undefined
): boolean {
  return Boolean(campaignId && lineItemId && lineItemName);
}
